import { render } from "./LohnsteigerungBox.pug?vue&type=template&id=77c2d6d2&lang=pug"
import script from "./LohnsteigerungBox.js?vue&type=script&lang=js"
export * from "./LohnsteigerungBox.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__